import { NavListItem, NavListSectionHeader } from "#root/components/nav-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { MdEdit, MdSearch } from "react-icons/md";
import { NavLink, useParams } from "react-router-dom";
import Layout from "../layout";

export default function (props: Parameters<typeof Layout>["0"]): ReactNode {
  const { correspondenceId } = useParams();

  return (
    <Layout
      {...props}
      correspondenceElements={
        correspondenceId && (
          <Fragment>
            <NavListSectionHeader>Correspondence CI-{correspondenceId}</NavListSectionHeader>
            <NavLink end to={`/billing/correspondence/${correspondenceId}`}>
              <NavListItem icon={MdSearch}>Preview & Send</NavListItem>
            </NavLink>
            <NavLink to={`/billing/correspondence/${correspondenceId}/edit`}>
              <NavListItem icon={MdEdit}>Edit</NavListItem>
            </NavLink>
          </Fragment>
        )
      }
    />
  );
}
